import isEmpty from "lodash/isEmpty"
import get from "lodash/get"
import filter from "lodash/filter"
import getContentUrl from "utils-lib/getContentUrl"
import { getWindow } from "utils-lib/getWindow"

const ssrWindow = getWindow()

const URL_IMG_PIN_RECYCLE = `/content/dam/wm/icons/single-use/drop-off-map/location-pin-recycle.svg`
const URL_IMG_PIN_RECYCLE_SELECTED = `/content/dam/wm/icons/single-use/drop-off-map/location-pin-recycle-selected.svg`
const URL_IMG_PIN_RECYCLE_ALERT = `/content/dam/wm/icons/single-use/drop-off-map/location-pin-recycle-alert.svg`
const URL_IMG_PIN_RECYCLE_ALERT_SELECTED = `/content/dam/wm/icons/single-use/drop-off-map/location-pin-recycle-alert-selected.svg`

const URL_IMG_PIN_TRASH = `/content/dam/wm/icons/single-use/drop-off-map/location-pin-trash.svg`
const URL_IMG_PIN_TRASH_SELECTED = `/content/dam/wm/icons/single-use/drop-off-map/location-pin-trash-selected.svg`
const URL_IMG_PIN_TRASH_ALERT = `/content/dam/wm/icons/single-use/drop-off-map/location-pin-trash-alert.svg`
const URL_IMG_PIN_TRASH_ALERT_SELECTED = `/content/dam/wm/icons/single-use/drop-off-map/location-pin-trash-alert-selected.svg`

const URL_IMG_PIN_LOCATION = `/content/dam/wm/icons/solid- green-location-arrow-pin-icon.svg`

// Get the width, height and url for a faciliy map marker icon.
const getSelectedPlainOrAlertIcon = (facTypeCode, hasFacilityAlert) => {
  if (facTypeCode === `2` || facTypeCode === `4`) {
    return hasFacilityAlert
      ? URL_IMG_PIN_TRASH_ALERT_SELECTED
      : URL_IMG_PIN_TRASH_SELECTED
  }
  if (facTypeCode === `3`) {
    return hasFacilityAlert
      ? URL_IMG_PIN_RECYCLE_ALERT_SELECTED
      : URL_IMG_PIN_RECYCLE_SELECTED
  }
  return ``
}

const getPlainOrAlertIcon = (facTypeCode, hasFacilityAlert) => {
  if (facTypeCode === `2` || facTypeCode === `4`) {
    return hasFacilityAlert ? URL_IMG_PIN_TRASH_ALERT : URL_IMG_PIN_TRASH
  }
  if (facTypeCode === `3`) {
    return hasFacilityAlert ? URL_IMG_PIN_RECYCLE_ALERT : URL_IMG_PIN_RECYCLE
  }
  return ``
}

const getFacilityMapMarkerIcon = (
  facTypeCode,
  facId,
  selectedFacId,
  hoveredFacId,
  listItemSelected,
  hasFacilityAlert,
) => {
  const isLocationSelected = facId === selectedFacId
  const isLocationHovered = facId === hoveredFacId
  const isAnyLocationHovered = hoveredFacId !== null
  const iconSizeFactor = 1
  let iconUrl = ``
  let iconWidth = 0
  let iconHeight = 0
  if (!isAnyLocationHovered || isLocationHovered) {
    iconWidth = 69 * iconSizeFactor
    iconHeight = 59 * iconSizeFactor
    if (isLocationHovered) {
      iconUrl = getSelectedPlainOrAlertIcon(facTypeCode, hasFacilityAlert)
    } else if (isLocationSelected) {
      iconWidth = 86 * iconSizeFactor
      iconHeight = 100 * iconSizeFactor
      iconUrl = getSelectedPlainOrAlertIcon(facTypeCode, hasFacilityAlert)
    } else if (
      facTypeCode === `2` ||
      facTypeCode === `4` ||
      facTypeCode === `3`
    ) {
      iconUrl = getPlainOrAlertIcon(facTypeCode, hasFacilityAlert)
    } else {
      iconUrl = URL_IMG_PIN_LOCATION
    }
  }

  const iconSize = new ssrWindow.google.maps.Size(
    iconWidth, // width
    iconHeight, // height
    `px`, // width unit
    `px`, // height unit
  )
  const googleMapIcon = {
    scaledSize: iconSize,
    // size: iconSize,
    url: getContentUrl(iconUrl),
  }

  return googleMapIcon
}

export default (
  facLocations,
  selectedFacTypeCode,
  selectedFacId,
  hoveredFacId,
  listItemSelected,
  facilityAlerts,
) => {
  const filteredMapLocations = filter(facLocations, (loc) => {
    if (selectedFacTypeCode === `drop_off_waste`) {
      return (
        loc.properties.facTypeCode === `2` || loc.properties.facTypeCode === `4`
      )
    }
    return loc.properties.facTypeCode === `3`
  })
  return filteredMapLocations.map((item) => {
    const uniqueId = get(item, `properties.uniqueId`, ``)
    const hasFacilityAlert = !isEmpty(
      filter(
        facilityAlerts,
        (alert) => get(alert, `facilities.id`, ``) === uniqueId,
      ),
    )
    const facTypeCode = get(item, `properties.facTypeCode`, ``)
    return {
      icon: getFacilityMapMarkerIcon(
        facTypeCode,
        uniqueId,
        selectedFacId,
        hoveredFacId,
        listItemSelected,
        hasFacilityAlert,
      ),
      position: {
        lat: item.geometry.coordinates[1],
        lng: item.geometry.coordinates[0],
      },
      title: item.properties.name,
      uniqueId,
    }
  })
}
